const STEPS = [
  { n: "01", title: "Free discovery call", body: "30-min call to understand your business, traction and funding goals. No commitment." },
  { n: "02", title: "Deep-dive & documents", body: "We collect financials, contracts, market data and KPIs — then dig in." },
  { n: "03", title: "Build model + data room", body: "Investor-grade financial model and a clean, shareable data room — typically in 2 weeks." },
  { n: "04", title: "Submit & follow up", body: "We tailor the grant or VC application, submit, and stay with you through investor Q&A." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative bg-cream py-24 sm:py-32 bg-kente">
      <div className="mx-auto max-w-7xl px-6 sm:px-12">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.2em] text-terracotta">How it works</p>
            <h2 className="mt-3 font-display text-4xl font-semibold text-umber sm:text-5xl">
              Four steps from idea to <span className="italic">funded.</span>
            </h2>
          </div>
          <p className="max-w-md text-umber/70">
            A clear, predictable process — refined across <strong>120+</strong> grant and equity engagements.
          </p>
        </div>

        <ol className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              data-testid={`step-card-${i}`}
              className="relative rounded-2xl border border-umber/10 bg-white p-7 transition hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="font-display text-5xl font-light text-terracotta/70">{s.n}</div>
              <h3 className="mt-4 font-display text-xl font-semibold text-umber">{s.title}</h3>
              <p className="mt-2 text-sm text-umber/70 leading-relaxed">{s.body}</p>
              {i < STEPS.length - 1 && (
                <span className="absolute right-4 top-9 hidden text-2xl text-umber/15 lg:inline">→</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
